import { render, staticRenderFns } from "./mirrors.vue?vue&type=template&id=02c9c57c&"
import script from "./mirrors.vue?vue&type=script&lang=js&"
export * from "./mirrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports